var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.author
    ? _c("section", [
        _c("div", { staticClass: "author-metadata" }, [
          _c("div", { staticClass: "row title" }, [
            _c("div", { staticClass: "col-md-8 col-sm-6 col-4 pl-0" }, [
              _c(
                "h5",
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.author.seq + 1) +
                      ".\n\n                    "
                  ),
                  _vm._v(" "),
                  _vm.author.author_type == "I"
                    ? [
                        _vm.author.first_name != null ||
                        _vm.author.last_name != null
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.author.first_name) +
                                    " " +
                                    _vm._s(_vm.author.last_name)
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                },
                              },
                              [_vm._v("New individual author")]
                            ),
                      ]
                    : _vm.author.author_type == "G"
                    ? [
                        _vm.author.group_name != null
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.author.group_name))]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                },
                              },
                              [_vm._v("New group author")]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 col-sm-6 col-8 actions" }, [
              _c(
                "a",
                {
                  class: { deactive: _vm.disabled },
                  on: {
                    click: function ($event) {
                      return _vm.$modal.show("article-authors-reorder")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-arrows-alt" }),
                  _vm._v(" Reorder authors\n                "),
                ]
              ),
              _vm._v(" | "),
              _c(
                "a",
                {
                  class: { deactive: _vm.disabled },
                  on: { click: _vm.removeAuthor },
                },
                [
                  _c("i", { staticClass: "fa fa-trash-alt" }),
                  _vm._v(" Delete\n                "),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("section", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12 content-padding keyword" },
                  [
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v(
                        "\n                            Please select the most appropriate author type.\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        class: { deactive: _vm.disabled },
                        staticStyle: { "margin-right": "24px" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.author.author_type,
                              expression: "author.author_type",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            value: "I",
                            id:
                              "author-type-individual-" + _vm.author.author_id,
                          },
                          domProps: {
                            checked: _vm._q(_vm.author.author_type, "I"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.author, "author_type", "I")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("b", [_vm._v("Individual author")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "radio" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { class: { deactive: _vm.disabled } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.author.author_type,
                            expression: "author.author_type",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          value: "G",
                          id: "author-type-group-" + _vm.author.author_id,
                        },
                        domProps: {
                          checked: _vm._q(_vm.author.author_type, "G"),
                        },
                        on: {
                          change: [
                            function ($event) {
                              return _vm.$set(_vm.author, "author_type", "G")
                            },
                            function ($event) {
                              _vm.author.primary_contact = null
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b",
                        [
                          _vm._v(
                            "\n                                Collaborative (group) Author\n                                "
                          ),
                          _c(
                            "jmir-popover",
                            { attrs: { position: "right" } },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-question-circle tooltip-target b3",
                              }),
                              _vm._v(" "),
                              _c("template", { slot: "content" }, [
                                _c("p", [
                                  _vm._v(
                                    "\n                                            A group of authors (contributors) credited under one\n                                            name, either as a collaboration or when an organization,\n                                            institution, or corporation is the value. If authors\n                                            wish to acknowledge a group that is not a co-author,\n                                            groups can be mentioned using the field “Written on\n                                            behalf of”, in which case the group will appear in the\n                                            affiliation footnote of the respective individual\n                                            author, but the article will not be indexed with the\n                                            group as co-value. For individual members of the group\n                                            to be listed in PubMed as contributors, enter\n                                            contributors below. Contributors can also be mentioned\n                                            in the Acknowledgements section of the manuscript.\n                                        "
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "radio" }),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("form", { attrs: { autocomplete: "off" } }, [
                      _vm.author.author_type == "I"
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { margin: "0 auto" },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-md-12 pl-0",
                                  class: { deactive: _vm.disabled },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.primary_contact,
                                        expression: "author.primary_contact",
                                      },
                                    ],
                                    attrs: { type: "radio" },
                                    domProps: {
                                      value: 1,
                                      checked: _vm._q(
                                        _vm.author.primary_contact,
                                        1
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.adjustCorrespondingDetails(
                                          _vm.orderedAuthors,
                                          _vm.index
                                        )
                                      },
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.author,
                                          "primary_contact",
                                          1
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                                    Corresponding author for this submission\n                                    "
                                  ),
                                  _c("span", { staticClass: "radio" }),
                                  _vm._v(" "),
                                  _c(
                                    "jmir-popover",
                                    { attrs: { position: "right" } },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-question-circle tooltip-target b3",
                                      }),
                                      _vm._v(" "),
                                      _c("template", { slot: "content" }, [
                                        _c("p", [
                                          _vm._v(
                                            '\n                                                Indicates whether the named contributor (e.g., an\n                                                author should receive correspondence, i.e., the\n                                                attribute is set to "yes"; if the contributor is a\n                                                corresponding value.\n                                            '
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                                        Note: Only one corresponding author can be assigned. If\n                                        you wish to change the corresponding author, please select\n                                        another author as the corresponding value.\n                                    "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4" },
                                [
                                  _c("label", { staticClass: "asterik" }, [
                                    _vm._v("First name"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.first_name,
                                        expression: "author.first_name",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      required: " required",
                                      name:
                                        "first name of author " +
                                        (_vm.index + 1) +
                                        "",
                                    },
                                    domProps: { value: _vm.author.first_name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "first_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-error" }),
                                  _vm._v(" "),
                                  _vm.hasError(_vm.index + "." + "first_name")
                                    ? _c(
                                        "small",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.hasError(
                                                _vm.index + "." + "first_name",
                                                true
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4" },
                                [
                                  _c("label", [_vm._v("Middle name")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.middle_name,
                                        expression: "author.middle_name",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { deactive: _vm.disabled },
                                    attrs: {
                                      type: "text",
                                      required: "required",
                                    },
                                    domProps: { value: _vm.author.middle_name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "middle_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4" },
                                [
                                  _c("label", { staticClass: "asterik" }, [
                                    _vm._v("Last name"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.last_name,
                                        expression: "author.last_name",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id:
                                        "" +
                                        "last name of author " +
                                        (_vm.index + 1) +
                                        "",
                                      type: "text",
                                      required: "required",
                                    },
                                    domProps: { value: _vm.author.last_name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "last_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-error" }),
                                  _vm._v(" "),
                                  _vm.hasError(_vm.index + "." + "last_name")
                                    ? _c(
                                        "small",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.hasError(
                                                _vm.index + "." + "last_name",
                                                true
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                                        Suffix\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "right" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [
                                              _vm._v(
                                                "\n                                                    Qualifiers that follow a person's name, for example\n                                                    Sr, Jr, III, 3rd, etc\n                                                "
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.suffix,
                                        expression: "author.suffix",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { deactive: _vm.disabled },
                                    attrs: {
                                      type: "text",
                                      required: "required",
                                    },
                                    domProps: { value: _vm.author.suffix },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "suffix",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4 mt-2" },
                                [
                                  _c("label", { staticClass: "asterik" }, [
                                    _vm._v("Email"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.email,
                                        expression: "author.email",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id:
                                        "" +
                                        "email of author " +
                                        (_vm.index + 1) +
                                        "",
                                      type: "email",
                                      required: "required",
                                      name:
                                        "email of author " +
                                        (_vm.index + 1) +
                                        "",
                                    },
                                    domProps: { value: _vm.author.email },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "email",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-error" }),
                                  _vm._v(" "),
                                  _vm.hasError(_vm.index + "." + "email")
                                    ? _c(
                                        "small",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.hasError(
                                                _vm.index + "." + "email",
                                                true
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-4" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "18px",
                                          "margin-right": "3px",
                                        },
                                        attrs: {
                                          src: "https://asset.jmir.pub/assets/static/images/orcidGreen.svg",
                                        },
                                      }),
                                      _vm._v(
                                        "ORCiD\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "left" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [
                                              _vm._v(
                                                "\n                                                    ORCID provides a persistent digital identifier that\n                                                    distinguishes you from every other researcher and,\n                                                    through integration in key research workflows such\n                                                    as manuscript and grant submission, supports\n                                                    automated linkages between you and your professional\n                                                    activities ensuring that your work is recognized.\n                                                    "
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "Sign up for an ORCID iD at\n                                                    "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "https://orcid.org/register",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "https://orcid.org/register"
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.orcid,
                                        expression: "author.orcid",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { deactive: _vm.disabled },
                                    attrs: {
                                      type: "text",
                                      name:
                                        "ORCID code of author " +
                                        (_vm.index + 1) +
                                        "",
                                    },
                                    domProps: { value: _vm.author.orcid },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "orcid",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-error" }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-6" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                                        Role\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "right" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [
                                              _vm._v(
                                                "\n                                                    “The title or role of a contributor, for example,\n                                                    Chief Scientist or Research Associate”.\n                                                "
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.role,
                                        expression: "author.role",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { deactive: _vm.disabled },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.author.role },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "role",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-6" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                                        Twitter handle\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "right" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [_vm._v("Some text")]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.author.twitter_handle,
                                        expression: "author.twitter_handle",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: { deactive: _vm.disabled },
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.author.twitter_handle,
                                    },
                                    on: {
                                      keydown: function ($event) {
                                        return _vm.checkTwitterInput(_vm.event)
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.author,
                                          "twitter_handle",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group col-md-12" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                                        Degrees\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "right" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [
                                              _vm._v(
                                                "\n                                                    “Academic titles or professional certifications,\n                                                    such as MD or PhD. Designations such as student,\n                                                    candidate, and professor are not permitted.”\n                                                "
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                                            Please add author degrees in the order they should\n                                            appear. Click and drag degrees to modify the order.\n                                        "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "multiselect-wrapper",
                                      class: { deactive: _vm.disabled },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-select vs--searchable vs--open display-multiselect",
                                        },
                                        [
                                          _vm.author.degrees &&
                                          _vm.authorDegree != ""
                                            ? _c(
                                                "draggable",
                                                {
                                                  on: {
                                                    start: function ($event) {
                                                      _vm.dragging = true
                                                    },
                                                    end: function ($event) {
                                                      _vm.dragging = false
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.author.degrees,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.author,
                                                        "degrees",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "author.degrees",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.author.degrees,
                                                  function (
                                                    authorDegree,
                                                    authorDegreeIndex
                                                  ) {
                                                    return _c(
                                                      "ul",
                                                      {
                                                        key: authorDegreeIndex,
                                                        staticClass:
                                                          "vs__selected vs__deselect selected-pills",
                                                      },
                                                      [
                                                        _c("li", [
                                                          _vm._v(
                                                            "\n                                                        " +
                                                              _vm._s(
                                                                authorDegree
                                                              ) +
                                                              "\n                                                        "
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "vs__deselect",
                                                              attrs: {
                                                                type: "button",
                                                                "aria-label":
                                                                  "deselect option",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deselectDegree(
                                                                      _vm.author
                                                                        .degrees,
                                                                      authorDegreeIndex
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  attrs: {
                                                                    xmlns:
                                                                      "http://www.w3.org/2000/svg",
                                                                    width: "10",
                                                                    height:
                                                                      "10",
                                                                  },
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        class: { deactive: _vm.disabled },
                                        attrs: {
                                          label: "authorDegree",
                                          multiple: "",
                                          taggable: "",
                                          "push-tags": "true",
                                          options: _vm.degrees,
                                        },
                                        model: {
                                          value: _vm.author.degrees,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.author, "degrees", $$v)
                                          },
                                          expression: "author.degrees",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("jselect", {
                                    key: "name",
                                    attrs: {
                                      options: _vm.countries,
                                      label: "country",
                                      disabled: _vm.disabled,
                                      "default-option": false,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm.author.author_type == "G"
                        ? _c("div", { staticClass: "row content-padding" }, [
                            _c("div", { staticClass: "form-group col-md-6" }, [
                              _c("label", { staticClass: "asterik" }, [
                                _vm._v("Group name"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.author.group_name,
                                    expression: "author.group_name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", required: "required" },
                                domProps: { value: _vm.author.group_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.author,
                                      "group_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-error" }),
                              _vm._v(" "),
                              _vm.hasError(_vm.index + "." + "group_name")
                                ? _c(
                                    "small",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.hasError(
                                            _vm.index + "." + "group_name",
                                            true
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group col-md-6" }, [
                              _c("label", { staticClass: "asterik" }, [
                                _vm._v("Email"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.author.email,
                                    expression: "author.email",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", required: "required" },
                                domProps: { value: _vm.author.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.author,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-error" }),
                              _vm._v(" "),
                              _vm.hasError(_vm.index + "." + "email")
                                ? _c(
                                    "small",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.hasError(
                                            _vm.index + "." + "email",
                                            true
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group col-md-12" }, [
                        _c(
                          "label",
                          [
                            _vm._v(
                              "\n                                    Equal contribution footnote\n                                    "
                            ),
                            _c(
                              "jmir-popover",
                              { attrs: { position: "right" } },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa fa-question-circle tooltip-target b3",
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "content" }, [
                                  _c("p", [
                                    _vm._v(
                                      '\n                                                Indicates whether all contributors contributed\n                                                equally. If the contributor whom this attribute\n                                                modifies contributed equally with all other\n                                                contributors, this attribute should be set to "yes";\n                                                if his/her contribution was greater or lesser, then\n                                                this attribute should be set to "no". Usage notes:\n                                                This attribute - defined by the NLM - is unfortunately\n                                                quite confusing and ambiguous, because whether "This\n                                                contributor did not participate equally with all other\n                                                contributors." indicates a greater or a lesser\n                                                contribution remains unclear. We recommend to select\n                                                "Unspecified" and to provide a narrative in the\n                                                textbox "Authors\' Contributions" instead. ONLY use\n                                                this attribute in exceptional circumstances if you\n                                                want to render an equal contribution footnote for the\n                                                main authors, e.g. the FIRST TWO AUTHORS or THE FIRST\n                                                AND THE LAST AUTHOR, by checking "YES" for these\n                                                authors. JMIR will render the footnote "These authors\n                                                contributed equally to this work" for the authors\n                                                where this attribute is set to "YES", implying that\n                                                the contributions of the authors set to \\"NO\\" has\n                                                been lesser\n                                            '
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                        Selected authors receive a footnote declaring “These\n                                        authors contributed equally”. Equal contribution can be\n                                        selected for a select number of authors or all authors.\n                                    "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.author.equal_contrib,
                                expression: "author.equal_contrib",
                              },
                            ],
                            staticClass: "form-control dropdown",
                            class: { deactive: _vm.disabled },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.author,
                                  "equal_contrib",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Unspecified (no footnote) "),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("Yes"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("No"),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group col-md-12" }, [
                        _c(
                          "label",
                          [
                            _vm._v(
                              "\n                                    Written on behalf of\n                                    "
                            ),
                            _c(
                              "jmir-popover",
                              { attrs: { position: "right" } },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa fa-question-circle tooltip-target b3",
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "content" }, [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                                When a contributor has written or edited a piece of\n                                                work on behalf of an organization or group, the\n                                                contributor is acting as a representative of the\n                                                organization. This group or organization the author is\n                                                representing may or may not be the author’s usual\n                                                affiliation. For example, a physician affiliated with\n                                                St. Luke’s Hospital may be writing on behalf of the\n                                                Multiple Sclerosis Collaborative Research Group. If an\n                                                author is writing on behalf of a group that is also\n                                                considered an author, please add this group as a group\n                                                author by adding a collaborative (group) value.\n                                            "
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                        If this author is writing on behalf of a group,\n                                        organization, or institution, enter the name here. If a\n                                        group entered here is also considered an author, please\n                                        add it as a group value.\n                                    "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.author.on_behalf,
                              expression: "author.on_behalf",
                            },
                          ],
                          staticClass: "form-control",
                          class: { deactive: _vm.disabled },
                          attrs: { type: "text", required: "required" },
                          domProps: { value: _vm.author.on_behalf },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.author,
                                "on_behalf",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.author.author_type == "G"
                        ? _c(
                            "div",
                            { staticClass: "row content-padding pb-0" },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group col-md-12" },
                                [
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                                        Collaborators\n                                        "
                                      ),
                                      _c(
                                        "jmir-popover",
                                        { attrs: { position: "right" } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-question-circle tooltip-target b3",
                                          }),
                                          _vm._v(" "),
                                          _c("template", { slot: "content" }, [
                                            _c("p", [
                                              _vm._v(
                                                "\n                                                    Collaborators for a group author should be\n                                                    acknowledged. These collaborators will appear in an\n                                                    expandable field under the group author in PubMed.\n                                                    Examples include members of a research group or\n                                                    participants of a consensus workshop.\n                                                "
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.author.collaborators,
                                    function (collaborator, collaboratorIndex) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row px-3 mx-1 mt-2 pb-2 border",
                                          staticStyle: {
                                            "background-color": "#f9f9f9",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group col-md-4",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "fname" } },
                                                [_vm._v("First Name")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      collaborator.firstName,
                                                    expression:
                                                      "collaborator.firstName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  deactive: _vm.disabled,
                                                },
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: collaborator.firstName,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      collaborator,
                                                      "firstName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group col-md-4",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "fname" } },
                                                [_vm._v("Middle Name")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      collaborator.middleName,
                                                    expression:
                                                      "collaborator.middleName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  deactive: _vm.disabled,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  required: "required",
                                                },
                                                domProps: {
                                                  value:
                                                    collaborator.middleName,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      collaborator,
                                                      "middleName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group col-md-4",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "fname" } },
                                                [_vm._v("Last Name")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      collaborator.lastName,
                                                    expression:
                                                      "collaborator.lastName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  deactive: _vm.disabled,
                                                },
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: collaborator.lastName,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      collaborator,
                                                      "lastName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "small",
                                              class: { deactive: _vm.disabled },
                                              attrs: { href: "javascript:;" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCollaborator(
                                                    collaborator,
                                                    collaboratorIndex
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-minus",
                                              }),
                                              _vm._v(
                                                "\n                                            Remove collaborator\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "subfield add" }, [
                                    _c(
                                      "a",
                                      {
                                        class: { deactive: _vm.disabled },
                                        on: { click: _vm.addCollaborator },
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " Add collaborator\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 content-padding" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-custom btn-custom-light-green btn-block",
                    class: { deactive: _vm.disabled },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.addAuthorAffiliation()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-plus",
                      staticStyle: { color: "#629F36" },
                    }),
                    _vm._v(" Add affiliation\n                    "),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            !_vm.disabled
              ? _c("div", { staticClass: "final-save-button" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-custom btn-custom-green mb-3",
                      attrs: { type: "button", href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.saveAuthor()
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "mt-1",
                        class: {
                          "spinner-grow spinner-grow-sm": _vm.authorLoading,
                        },
                        staticStyle: { float: "left", color: "white" },
                        attrs: { role: "status", "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    Save author\n                "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasError("*.authors")
              ? _c("small", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.hasError("*.authors", true)) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }